import { approvalId } from "@tanstack/ai-sandbox";
//#region src/process/permissions.ts
/** Permission categories treated as file mutations for `'acceptEdits'`. */
var EDIT_TYPES = /* @__PURE__ */ new Set([
	"edit",
	"write",
	"patch"
]);
/**
* Decide whether an OpenCode permission request targets one of the bridged
* TanStack tools. OpenCode names MCP tools `<server>_<tool>` (e.g.
* `tanstack_lookup_user`), so a request is bridged when its type or title is
* a registered tool name, or carries the `tanstack` server prefix.
*/
function matchBridgedToolName(request, bridgedToolNames) {
	if (!bridgedToolNames || bridgedToolNames.size === 0) return false;
	for (const field of [request.type, request.title]) {
		if (typeof field !== "string" || field === "") continue;
		if (bridgedToolNames.has(field)) return true;
		if (field.startsWith("tanstack_") && bridgedToolNames.has(field.slice(9))) return true;
		if (field.startsWith("tanstack.") && bridgedToolNames.has(field.slice(9))) return true;
	}
	return false;
}
/**
* The adapter's default permission policy. Always answers immediately — never
* hangs a headless server on a question only an interactive user could
* answer.
*/
function resolvePermission(request, mode, bridgedToolNames) {
	if (matchBridgedToolName(request, bridgedToolNames)) return "once";
	if (mode === "bypassPermissions") return "once";
	if (mode === "acceptEdits" && EDIT_TYPES.has(request.type)) return "once";
	return "reject";
}
/**
* Interactive variant: when the mode/bridge policy would reject, consult the
* client's approval decisions. Returns the OpenCode response plus, when the
* action still needs a client decision, the `approvalId`/`title` the adapter
* should surface via an `approval-requested` event.
*/
function resolveInteractivePermission(request, mode, bridgedToolNames, approvals) {
	if (matchBridgedToolName(request, bridgedToolNames)) return { response: "once" };
	if (mode === "bypassPermissions") return { response: "once" };
	if (mode === "acceptEdits" && EDIT_TYPES.has(request.type)) return { response: "once" };
	const id = approvalId({
		provider: "opencode",
		kind: "tool",
		target: request.type || request.title
	});
	const granted = approvals?.get(id);
	if (granted === true) return { response: "once" };
	if (granted === false) return { response: "reject" };
	return {
		response: "reject",
		approvalId: id,
		title: request.title
	};
}
//#endregion
export { matchBridgedToolName, resolveInteractivePermission, resolvePermission };

//# sourceMappingURL=permissions.js.map